import {
    APIResponse,
    Invoice,
    NonManagedPortfolioStatsData,
    StatsData,
} from '@acp/shared';
import HttpStatusCodes from 'http-status-codes';
import { getBFFApiClient } from '@acp/feature/auth';

export async function getOverdueInvoices({
    propertyManagerId = undefined,
}: {
    propertyManagerId?: string;
} = {}) {
    const response = await getBFFApiClient().get<APIResponse<{
        total: number;
        items: Invoice[];
    }>>(
        '/v1/invoice/analytics/overdue',
        {
            params: {
                propertyManagerId,
            },
        }
    );

    if (response.status !== HttpStatusCodes.OK || !response.data.success) {
        throw new Error('Failed to get overdue invoices');
    }

    return response.data.data;
}

export async function getStats(propertyManagerId?: number | string | null) {
    const response = await getBFFApiClient().get<APIResponse<StatsData>>(
        propertyManagerId === undefined || propertyManagerId === null
            ? '/v1/stats' : `/v1/stats?propertyManagerId=${propertyManagerId}`
    );

    if (response.status !== HttpStatusCodes.OK || !response.data.success) {
        throw new Error(`Failed to get stats: ${response.data.error}`);
    }

    return response.data.data;
}

export async function getNonManagedPortfolioStats() {
    const response = await getBFFApiClient().get<APIResponse<NonManagedPortfolioStatsData>>(
        '/v1/stats/integrated'
    );

    if (response.status !== HttpStatusCodes.OK || !response.data.success) {
        throw new Error(`Failed to get stats: ${response.data.error}`);
    }

    return response.data.data;
}

export async function optInPortfolioMirroring() {
    const response = await getBFFApiClient().post<APIResponse<unknown>>(
        '/v1/me/opt-in/portfolio-mirroring'
    );

    if (response.status !== HttpStatusCodes.OK || !response.data.success) {
        throw new Error('Failed to opt in');
    }

    return response.data.data;
}
